var LayoutEditor = Control.extend({
	init: function(p) {
		this.base('div', p);
		this._element.classList.add('layouteditor');
	},
	text: {
		get: function() {
			return(this.innerHTML);
		},
		set: function(value) {
			var parser = new DOMParser();
			var xml = parser.parseFromString(value, 'text/xml');
			value = xml.firstChild;
			if (value.firstChild) {
				(function(node, parent) {
					do {
						if (node.nodeType==3) {
							//newNode = parent.appendChild( new Text(node.nodeValue) );
						} else {
							var p = {'event': {}};
							var publicName=null;
							for(var i=0, collection=node.attributes; i<collection.length; i++) {
								if (collection[i].name.startsWith('on')) {
									//p[collection[i].name] = this[collection[i].value].bind(this);
								} else if (collection[i].name == 'name') {
									publicName = collection[i].value;
								} else {
									p[collection[i].name] = collection[i].value;
								}
							}

							var control = parent.appendChild( new (Control.nodeNameToObject(node.nodeName.toLowerCase()))(p) );

							if (publicName) {
								this[publicName] = control;
							}
				
							if (node.hasChildNodes())
								arguments.callee.call(this, node.firstChild, control);
						}

					} while(node=node.nextSibling);
				}).call(this, value.firstChild, this);
			}
		}
	}
});